module.exports = __webpack_public_path__ + "static/assets/2638e63095a6968dc76de778461e3dc4.png";